import * as React from "react";

const SvgArrowsWhite = (props) => (
  <svg
    className="arrows-white_svg__arrows-white"
    viewBox="0 0 280 293"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="M0 10.702a.32.32 0 0 1-.323.316h-29.094c-1.302 0-2.361 1.037-2.361 2.311v6.231a.296.296 0 0 1-.177.282.306.306 0 0 1-.335-.025L-52.483 5.705a.302.302 0 0 1-.138-.258c0-.075.024-.18.137-.258L-32.29-8.923v-.001a.329.329 0 0 1 .186-.062.34.34 0 0 1 .149.038.296.296 0 0 1 .177.282v6.23c0 1.275 1.059 2.311 2.361 2.311H-.323A.32.32 0 0 1 0 .192v10.51ZM-.323-2.995h-28.523v-5.671a3.169 3.169 0 0 0-1.766-2.834 3.31 3.31 0 0 0-3.382.241L-54.19 2.854a3.172 3.172 0 0 0-1.364 2.593c0 1.026.51 1.996 1.365 2.593l20.195 14.112a3.285 3.285 0 0 0 1.89.596c.508 0 1.02-.117 1.492-.355a3.166 3.166 0 0 0 1.766-2.833v-5.672H-.323c1.795 0 3.256-1.429 3.256-3.186V.192c0-1.758-1.461-3.187-3.256-3.187"
      style={{
        fill: "gray",
        fillRule: "nonzero",
      }}
      transform="translate(231.475 197.931) scale(4.16667)"
    />
    <path
      d="M0-10.315a.32.32 0 0 1 .323-.317h29.094c1.302 0 2.361-1.037 2.361-2.311v-6.23c0-.128.059-.224.176-.283a.31.31 0 0 1 .335.024L52.484-5.318a.3.3 0 0 1 .136.257c0 .075-.023.18-.136.258L32.289 9.31a.303.303 0 0 1-.336.024.296.296 0 0 1-.175-.281V2.822c0-1.274-1.059-2.31-2.361-2.31H.323A.32.32 0 0 1 0 .194v-10.509ZM.323 3.381h28.523v5.672c0 1.199.676 2.284 1.765 2.833a3.33 3.33 0 0 0 1.493.355c.664 0 1.326-.201 1.889-.596L54.188-2.467a3.176 3.176 0 0 0 1.366-2.594 3.172 3.172 0 0 0-1.366-2.592L33.993-21.766a3.295 3.295 0 0 0-3.381-.241 3.165 3.165 0 0 0-1.766 2.834v5.671H.323c-1.796 0-3.257 1.43-3.257 3.187V.194c0 1.758 1.461 3.187 3.257 3.187"
      style={{
        fill: "gray",
        fillRule: "nonzero",
      }}
      transform="translate(47.662 93.178) scale(4.16667)"
    />
  </svg>
);

export default SvgArrowsWhite;
